export default __webpack_public_path__ + "static/media/mail.833d3b17.jpg";